import { aiMessages } from '@atlaskit/editor-common/ai-messages';

import { createInsertBelow } from '../../actions/create-actions';
import { CONFIG_ITEM_KEYS } from '../../config-item-keys';
import type {
	EditorPluginAIConfigItemFactory,
	EditorPluginAIConfigItemFactoryOptions,
} from '../../config-items';

export type ExtractActionsActionType = 'define_action_items' | 'add_decisions';

type SmartlinkExtractActionsOptions = EditorPluginAIConfigItemFactoryOptions & {
	actionType: ExtractActionsActionType;
	smartlinkUrl: string;
};

type SmartlinkExtractActionsConfigItemFactory = (
	options: SmartlinkExtractActionsOptions,
) => ReturnType<EditorPluginAIConfigItemFactory>;

export const smartLinkExtractActions: SmartlinkExtractActionsConfigItemFactory = (
	options: SmartlinkExtractActionsOptions,
) => ({
	key: CONFIG_ITEM_KEYS.SMARTLINK_EXTRACT_ACTIONS,
	title: aiMessages.smartlinkAddDecisions,
	description: aiMessages.smartlinkAddDecisions,
	showInRefineDropdown: false,
	insertOnEmptySelection: true,
	// intentSchemaId is not being passed to the backend. it's used in `request-options-convo-ai.ts` for error logging
	intentSchemaId: 'smartlink_extract_actions_intent_schema.json',
	featureId: 'smartlink_extract_actions',
	adfPrompt: true,
	getRequestPayload: ({ locale, aiSessionId, contentAri }) => ({
		ai_feature_input: {
			feature: 'smartlink_extract_actions',
			feature_args: {
				smartlink_url: options.smartlinkUrl,
				smartlink_action_type: options.actionType,
			},
			locale,
			ai_session_id: aiSessionId,
			content_ari: contentAri,
		},
	}),
	actions: {
		empty: [createInsertBelow({ appearance: 'primary' })],
		selection: [createInsertBelow({ appearance: 'primary' })],
	},
	getBackendModel: () => {
		return 'assistance-service';
	},
});
